import BriefFormFields from "./BriefFormFields"
import type { Brief } from "./model"
import { useUpdateBriefMutation } from "./api"
import { useT } from "@/i18n"
import { ApiFormWrapper, FormSubmitButton } from "@/form"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/ui/components/ui/dialog"

type BriefFormValues = {
  name: string
  description: string | null
}

type Props = {
  readonly brief: Brief
  readonly open: boolean
  readonly onOpenChange: (open: boolean) => void
}

export default function BriefEditDialog({ brief, open, onOpenChange }: Props) {
  const { t } = useT("brief")
  const [updateBrief] = useUpdateBriefMutation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("editTitle")}</DialogTitle>
        </DialogHeader>
        <ApiFormWrapper<BriefFormValues>
          defaultValues={{ name: brief.name, description: brief.description }}
          resetKey={brief.id}
          action={(values) =>
            updateBrief({
              id: brief.id,
              name: values.name,
              description: values.description ?? "",
            })
          }
          successMessage={t("saved")}
          onSuccess={() => {
            onOpenChange(false)
          }}
        >
          <div className="flex flex-col gap-6">
            <BriefFormFields />
            <DialogFooter>
              <FormSubmitButton>{t("common:save")}</FormSubmitButton>
            </DialogFooter>
          </div>
        </ApiFormWrapper>
      </DialogContent>
    </Dialog>
  )
}
